import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import Typography from '@material-ui/core/Typography';

import MappingListItemComponent from './mappingListItem.component';

class MappingListComponent extends React.Component {
  constructor(props) {
    super(props);

    this.renderMappings = this.renderMappings.bind(this);
  }

  renderMappings() {
    const { metadata } = this.props;

    return _.map(metadata, (column, key) => (
      <MappingListItemComponent key={key} column={column} />
    ));
  }

  render() {
    const { metadata } = this.props;

    return (
      <List>
        <ListItem style={{ display: _.some(metadata, column => column.mapped) > 0 ? 'none' : 'block' }}>
          <Typography>No mapping defined</Typography>
        </ListItem>
        {this.renderMappings()}
      </List>
    );
  }
}

MappingListComponent.propTypes = {
  metadata: PropTypes.shape({
    key: PropTypes.string,
    name: PropTypes.string,
    mapped: PropTypes.bool,
  }).isRequired,
};

export default MappingListComponent;
